module.exports = __webpack_public_path__ + "img/content6.34579d59.png";